/**
 * ContextMenu.tsx
 * Right-click context menu for deleting nodes/edges.
 */
import type { ContextMenuState } from '../hooks/useContextMenu';

type ContextMenuProps = {
  contextMenu: ContextMenuState;
  onDelete: () => void;
};

export function ContextMenu({ contextMenu, onDelete }: ContextMenuProps) {
  if (!contextMenu) return null;

  return (
    <div
      className="fixed z-50 origin-top-left rounded-lg border border-border bg-card shadow-lg animate-[pop-in_120ms_ease-out]"
      style={{ left: contextMenu.x, top: contextMenu.y }}
    >
      <button
        onClick={onDelete}
        className="flex w-full items-center gap-2 px-6 py-3 text-base bg-red-600 text-white hover:bg-red-700 rounded-lg"
      >
        削除
      </button>
    </div>
  );
}

